'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = eauors;
var _utils = require('../utils/');
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function axisTextRotationUpdate(selection, options) {
  selection.selectAll('text').attr('transform', 'rotate(' + options.rotation + ' 0 ' + options.size + ')').style('text-anchor', _constants.TEXT_END);
}
function axisTextBaseline(selection, options) {
  selection.selectAll('text').each(function () {
    var element = d3.select(this);
    var offset = (0, _utils.fontBaselineOffset)(element, options.font.baseline);
    element.attr('transform', 'translate(0, ' + offset + ')');
  });
}
function axisEnter(selection, axis, options) {
  selection.call(axis);
  selection.selectAll('path').style((0, _utils.lineStyle)(options));
  selection.selectAll('line').style((0, _utils.lineStyle)(options.tick));
  selection.selectAll('text').style((0, _utils.fontStyle)(options.font));
}
function xAxisUpdate(selection, axis, options, offset, accessors) {
  axisEnter(selection, axis, options);
  axisTextBaseline(selection, options);
  if ((0, _utils.getScaleType)(axis.scale()) === _constants.ORDINAL && (0, _utils.ordinalLabelsOverlap)(selection, axis, 'x', options, _constants.UNROTATED)) {
    axisTextRotationUpdate(selection, options.font);
  }
  selection.attr('transform', 'translate(0, ' + offset(selection, axis, options) + ')');
}
function yAxisUpdate(selection, axis, options, offset) {
  axisEnter(selection, axis, options);
  selection.attr('transform', 'translate(' + offset(selection, axis, options) + ', 0)');
  axisTextBaseline(selection, options);
}
function xAxisLabelUpdate(selection, options, accessors) {
  selection.style({
    fill: function fill(datum) {
      return (0, _utils.getColor)(options, accessors.focusData(datum));
    }
  });
}
function yAxisLabelUpdate(selection, options, accessors) {
  selection.style({
    fill: function fill(datum) {
      return (0, _utils.getColor)(options, accessors.focusData(datum));
    }
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    yAxisEnter: axisEnter,
    yAxisUpdate: yAxisUpdate,
    xAxisEnter: axisEnter,
    xAxisUpdate: xAxisUpdate,
    xAxisLabelUpdate: xAxisLabelUpdate,
    yAxisLabelUpdate: yAxisLabelUpdate
  });
}